import { Component } from 'react';
import { AppConstants } from '../APIConstants';

class SessionStorageService extends Component {
    static getSessionStorageAuth() {
        if (sessionStorage.getItem(AppConstants.AUTHTOKEN)) {
            let idToken = JSON.parse(sessionStorage.getItem(AppConstants.AUTHTOKEN));
            return Promise.resolve({
                token: idToken.token,
                userName: idToken.userName,
                displayName: idToken.displayName,
                IsLoggedIn: true,
                roles: idToken.roles
            });
        }
    }
    static setAuthToken(token) {
        sessionStorage.setItem(AppConstants.AUTHTOKEN, JSON.stringify(token));
    }
    static removeAuthToken() {
        sessionStorage.removeItem(AppConstants.AUTHTOKEN)
    }
}
export default SessionStorageService;